import { z } from 'zod';
import { UseSchema } from '../../common';

export const projectAccessControlPolicySettingsUpdateDtoSchema = z.object({
  allowSourceModelDownload: z
    .boolean()
    .describe('Allow downloading the source model input file from the project files list'),
});

@UseSchema(projectAccessControlPolicySettingsUpdateDtoSchema)
export class ProjectAccessControlPolicyUpdateSettingsDto {}
export interface ProjectAccessControlPolicyUpdateSettingsDto extends z.input<
  typeof projectAccessControlPolicySettingsUpdateDtoSchema
> {}
